const scrolly = require("../assets/js/jquery.scrolly.min.js");

export default window.scrolly = scrolly;
